import { RESOURCE_CENTER_URL } from 'constants/resourceCenterUrls';

export const primaryMenu = [
  {
    key: 'dashboard',
    name: 'Dashboard',
    link: '/dashboard',
    icon: 'Chart.Assessment',
  },
  {
    key: 'property',
    name: 'Portfolio',
    icon: 'HomePlaces.MapsHomeWork',
    showCancellationIcon: true,
    child: [
      {
        key: 'properties',
        name: 'Properties',
        link: '/property/properties',
        icon: 'HomePlaces.Apartment',
      },
      {
        key: 'applications',
        name: 'Applications',
        link: '/property/applications',
        icon: 'HomePlaces.Villa',
      },
      {
        key: 'policies',
        name: 'Policies',
        link: '/property/policies',
        icon: 'Security.Policy',
      },
      {
        key: 'cancel-policies',
        name: 'Flagged Cancellations',
        link: '/property/cancel-policies',
        showCancellationIcon: true,
        icon: 'General.Flag',
      },
      {
        key: 'claims',
        name: 'Claims',
        link: '/property/claims',
        icon: 'EditorLayout.EditNote',
      },
    ],
  },
  {
    key: 'invoice',
    name: 'Invoice',
    icon: 'FileFolder.ReceiptLong',
    link: '/invoice',
  },
  {
    key: 'user',
    name: 'Users',
    icon: 'Users.ManageAccounts',
    child: [
      {
        key: 'treeview',
        name: 'Tree View',
        link: '/user/treeview',
        icon: 'Users.User',
      },
      {
        key: 'll',
        name: 'Operator',
        link: '/user/operator',
        icon: 'Users.User',
      },
      {
        key: 'vp',
        name: 'Full Portfolio',
        link: '/user/full-portfolio',
        icon: 'Users.User',
      },
      {
        key: 'rm',
        name: 'Multi-Site',
        link: '/user/multi-site',
        icon: 'Users.User',
      },
      {
        key: 'pm',
        name: 'Property Manager',
        link: '/user/property',
        icon: 'Users.User',
      },
    ],
  },
  {
    key: 'add-users',
    name: 'Add Users',
    icon: 'Users.PersonAdd',
    child: [
      {
        key: 'company-invite',
        name: 'Operator Invite',
        link: '/operator-invite',
        icon: 'Users.PersonAdd',
      },
      {
        key: 'email',
        name: 'Invitations',
        link: '/invitations',
        icon: 'Notifications.Email',
      },
      {
        key: 'notification',
        name: 'Notification',
        link: '/notification',
        icon: 'Notifications.Notifications',
      },
      {
        key: 'invite-new-user',
        name: 'Invite New User',
        link: '/user/invite-new-user',
        // icon: 'Users.User',
      },
    ],
  },
  {
    key: 'delegation',
    name: 'Delegation',
    icon: 'Arrow.ApprovalDelegation',
    child: [
      {
        key: 'invite',
        name: 'Invite',
        link: '/invite',
      },
      {
        key: 'request',
        name: 'Request',
        link: '/request',
      },
    ],
  },
];

export const secondaryMenu = [
  {
    key: 'guide',
    name: 'Portal Guide',
    icon: 'FileFolder.CloudAssignment',
    link: '/guide',
  },
  {
    key: 'cancellationlog',
    name: 'Policy Cancel Log',
    icon: 'FileFolder.IntegrationInstructions',
    link: '/cancellation-log',
  },
  {
    key: 'activelog',
    name: 'Activity Log',
    icon: 'FileFolder.IntegrationInstructions',
    link: '/active-log',
  },
  {
    key: 'reportissue',
    name: 'Report an issue',
    icon: 'General.BugReport',
    link: 'https://leappartners.zendesk.com/hc/en-us/requests/new?ticket_form_id=40401336507031&tf_subject=Leap%20Portal%20Feedback&tf_40387458246039=product_feedback__portal_feedback&tf_description=Please%20attach%20any%20information%20and%20supporting%20evidence%20for%20your%20feedback%20below',
    isExternal: true,
  },
  {
    key: 'resourcecenter',
    name: 'Resource Center',
    icon: 'General.Report',
    link: RESOURCE_CENTER_URL,
    isExternal: true,
  },
];
